import { Image } from 'expo-image';
import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { ShowEpisode } from '@/api/models/showModels';
import { bs_icon } from '@/assets/images';
import { firebaseImage, safeJsonParseArray } from '@/utils/firebaseImage';

import Text from '../Text';

interface EpisodeCardParams {
  item: ShowEpisode;
  onPress: () => void;
}

const EpisodeCard = ({ item, onPress }: EpisodeCardParams) => {
  return (
    <TouchableOpacity style={styles.flexOne} onPress={onPress} disabled={item.muxPlaybackId === 'undefined'}>
      <View>
        <View style={styles.container}>
          <Image
            style={styles.thumb}
            source={
              item.thumbnail !== undefined ? firebaseImage(safeJsonParseArray(item.thumbnail ?? '[]').at(0)) : bs_icon
            }
          />
          <View style={styles.textContainer}>
            <Text fontWeight="700" ellipsizeMode="tail" numberOfLines={2} style={styles.title}>
              {item.title}
            </Text>
            {item.durationTime && <Text style={styles.duration}>{item.durationTime}</Text>}
          </View>
        </View>

        <Text style={styles.description}>{item.description}</Text>
        {item.muxPlaybackId === 'undefined' && <View style={styles.disabledOverlay} />}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  },

  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10
  },

  thumb: {
    width: 160,
    height: 120,
    borderRadius: 20,
    overflow: 'hidden'
  },

  textContainer: {
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-start'
  },

  title: {
    color: 'white',
    fontSize: 16
  },

  description: {
    color: 'gray',
    marginTop: 15
  },

  duration: {
    color: 'gray'
  },

  disabledOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

export default React.memo(EpisodeCard);
